import { render, staticRenderFns } from "./NoteBlockDropHelper.vue?vue&type=template&id=18b0e3e7&"
import script from "./NoteBlockDropHelper.vue?vue&type=script&lang=js&"
export * from "./NoteBlockDropHelper.vue?vue&type=script&lang=js&"
import style0 from "./NoteBlockDropHelper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports